import React from "react";
import Grid from "../Grid/Grid";
import Image from "../Image/Image";
import { GlobalContext } from "../../context/GlobalContext";
import ImageTextLayout from "../Image/ImageTextLayout";

function BookRecommendationElement({ author, cover, link, summary, title }) {
  const { isMobile } = React.useContext(GlobalContext);
  if (isMobile)
    return (
      <>
        <Grid>
          <h4
            className="text-light text-truncate col-12"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={title}
          >
            {title}
          </h4>
          <p className="text-muted col-12 book-recommendation-edit-margin">
            {author}
          </p>

          <ImageTextLayout link={link} imageSource={cover} text={summary} />
        </Grid>
        <br />
      </>
    );

  return (
    <>
      <Grid>
        <div className="col-2">
          <a href={link} target="_blank" className="document-container-link">
            <Image
              width={160}
              height={240}
              source={cover}
              alternativetext="Book cover caption"
            />
          </a>
        </div>

        <div className="col-10">
          <a
            href={link}
            target="_blank"
            className="book-recommendation-title-link"
          >
            <h4 className="text-light text-truncate" title={title}>
              {title}
            </h4>
          </a>
          <p className="text-muted book-recommendation-edit-margin">{author}</p>
          <p
            className="text-light book-recommendation-summary-overflow"
            title={summary}
          >
            {summary}
          </p>
        </div>
      </Grid>
      <br />
    </>
  );
}

export default BookRecommendationElement;
